import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface MessageDialogProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  message: string;
  type?: "success" | "error" | "info";
}

const MessageDialog: React.FC<MessageDialogProps> = ({ open, onClose, title = "Message", message, type = "info" }) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className={type === "error" ? "text-red-600" : type === "success" ? "text-green-600" : ""}>{title}</DialogTitle>
        </DialogHeader>
        <div className="py-4 text-base">
          {message}
        </div>
        <Button onClick={onClose} className="w-full mt-2">OK</Button>
      </DialogContent>
    </Dialog>
  );
};

export default MessageDialog;
